<template>
  <!-- Loading -->
  <div class="vld-parent">
    <loading
      v-model:active="isLoading"
      :is-full-page="true"
      :height="128"
      :width="128"
    />
  </div>

  <main-section>
    <!-- <div style="padding: 0px 16px 60px 16px;"> -->
    <!-- <div class="flex bg-gr ay-100 dark:bg-gray-600 text-black w-full h-screen transition-position duration-700"> -->
    <!-- <span class="text-bold"><img src="../assets/general/logo-amatra.png" alt="logo"></span> -->
    <div class="full-page-container">
      <!-- Content Left -->
      <div class="dashboard-container">
        <!-- Field Cut Off Date -->
        <div class="cutoff-container">
          <field class="cutoff" :label="$t('outstanding.cutoff')">
            <datepicker
              v-model="filter.cutoff"
              :enableTimePicker="false"
              class="date-picker"
            />
          </field>
        </div>

        <!-- Field Category -->
        <div class="category-container">
          <span>Category {{ isAsideMobileExpanded }}</span>
          <div class="select-box">
            <check-radio-picker
              v-model="filter.type"
              :options="{ 1: $t('vastudent.siswa') }"
              @change="changeValue()"
            ></check-radio-picker>
            <check-radio-picker
              v-model="filter.typecalon"
              :options="{ 1: $t('vastudent.calonsiswa') }"
              @change="changeValue()"
            ></check-radio-picker>
          </div>
        </div>

        <hr class="divider" />

        <div class="payment-dashboard">
          <field label="Payment Reconciliation">
            <CardBoxTransaction
              v-for="(data, index) in rowDataUploadVA.value"
              :key="index"
              :uploadva="data.uploadva"
              :payment="data.payment"
              :bank="$t('dashboard.bank')"
              :transaction="$t('dashboard.transaction')"
              :class="data.same ? 'payment-box' : 'invoice-box'"
            />
          </field>
        </div>
        <div class="flex flex-row">
          <div class="w-1/2 p-1 bg-white-200">
            <field label="Inv Overdue > 3 months">
              <div class="invoice-container">
                <CardBoxSiswa
                  v-for="(data, index) in rowDataInvoice.value"
                  :key="index"
                  :name="data.student_name"
                  :nis="data.student_number"
                  :kelas="data.class_name"
                  :value="data.total"
                  :cutoff="filter.cutoff"
                  :id="data.idsiswa"
                  :department_id="data.depart_ids"
                  :jml_inv="data.count"
                  :min_inv="data.min_age"
                  :max_inv="data.max_age"
                  :is_active="data.is_active"
                  :no="index+1"
                  class="bg-red-200"
                />
              </div>
            </field>
          </div>
          <div class="w-1/2 p-1">
            <!-- Right column content -->
            <field label="Waiver Overdue">
              <div class="waivers-container">
                <CardBoxWaiver
                  v-for="(data, index) in rowDataWaiver.value"
                  :key="index"
                  :prop-waiver="data"
                  :no="index+1"
                />
              </div>
            </field>
          </div>
        </div>
      </div>

      <!-- Content Right -->
      <div class="outstanding-wrapper">
        <div class="dashboard-container">
          <field label="Outstanding Composition">
            <vue3-chart-js
              v-bind="{ ...pieChart }"
              ref="chartRefPie"
              style="
                width: 100%;
                max-width: 100%;
                height: 300px;
                max-height: 300px;
              "
            />
          </field>
        </div>

        <card-component
          v-if="filteredData.value"
          :title="$t('Open Payment')"
          :generatePaymentShow="true"
          @generate-payment="generatePayment()"
          :closePaymentShow="true"
          @close-payment="closePayment()"
          has-table
        >
          <ag-grid-vue
            style="width: 100%; height: 70vh"
            class="ag-theme-alpine"
            :defaultColDef="defaultColDef"
            :columnDefs="columnDefs"
            :pagination="true"
            :context="context"
            @grid-ready="onGridReady"
            :rowData="filteredData.value"
            :rowSelection="rowSelection"
            :suppressRowClickSelection="true"
            @row-selected="onRowSelected($event)"
          />
        </card-component>

        <card-component
          v-else
          style="padding-left: 0px !important; padding-right: 0px !important"
          :title="$t('Open Payment')"
          has-table
        >
          <div class="text-center py-20 px-4 text-gray-500 dark:text-gray-400">
            No Data.
          </div>
        </card-component>
      </div>
    </div>

    <!-- </div> -->
    <div class="rate-container">
      <div class="w-full mb-5">
        <div class="filter-content">
          <field label="Collectible Rate (In %)">
            <div class="grid grid-cols-3 gap-4">
              <control
                type="number"
                v-model="filter.chartfail"
                @change="changeValue()"
              />
              <control
                type="number"
                v-model="filter.chartwarning"
                @change="changeValue()"
              />
              <control
                type="number"
                v-model="filter.chartsuccess"
                @change="changeValue()"
              />
            </div>
          </field>
        </div>
      </div>
      <h1
        class="text-2xl font-bold text-center mb-4"
        v-if="rowDataCutoff.length > 0"
      >
        Current Month
      </h1>
      <div class="grid grid-cols-3 gap-4" v-if="rowDataCutoff.length > 0">
        <div v-for="(data, index) in rowDataCutoff" v-bind:key="index">
          <div
            data-toggle="tooltip"
            :title="data.infohover"
            @click="klikDataChart(data.title)"
          >
            <vue-speedometer
              class="w-auto max-w-[500px]"
              :width="280"
              :height="200"
              :needleHeightRatio="0.7"
              :maxSegmentLabels="10"
              :segments="10"
              :forceRender="true"
              :customSegmentStops="[
                0,
                filter.chartfail,
                filter.chartwarning,
                filter.chartsuccess,
              ]"
              :segmentColors="['firebrick', 'gold', 'limegreen']"
              :minValue="0"
              :maxValue="100"
              :value="currencyFormatter(data.persen)"
              :currentValueText="data.title"
            />
          </div>
        </div>
      </div>

      <div style="background-color: black; height: 3px !important"></div>
      <h1 class="text-2xl font-bold text-center mb-4" v-if="rowData.length > 0">
        Cumulative
      </h1>
      <div class="grid grid-cols-3 gap-4" v-if="rowData.length > 0">
        <div v-for="(data, index) in rowData" v-bind:key="index">
          <div
            data-toggle="tooltip"
            :title="data.infohover"
            @click="klikDataChart(data.title)"
          >
            <vue-speedometer
              class="w-auto max-w-[500px]"
              :width="280"
              :height="200"
              :needleHeightRatio="0.7"
              :maxSegmentLabels="10"
              :segments="10"
              :forceRender="true"
              :customSegmentStops="[
                0,
                filter.chartfail,
                filter.chartwarning,
                filter.chartsuccess,
              ]"
              :segmentColors="['firebrick', 'gold', 'limegreen']"
              :minValue="0"
              :maxValue="100"
              :value="currencyFormatter(data.persen)"
              :currentValueText="data.title"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->
  </main-section>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import { computed, ref, onMounted, onBeforeMount, reactive, watch } from "vue";
import { useStore } from "vuex";
import {
  mdiAccountMultiple,
  mdiCartOutline,
  mdiChartTimelineVariant,
  mdiFinance,
  mdiMonitorCellphone,
  mdiReload,
  mdiGithub,
  mdiMagnify,
} from "@mdi/js";
import Chart from "chart.js/auto";
import * as chartConfig from "@/components/Charts/chart.config";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import Field from "@/components/Field";
import MainSection from "@/components/MainSection";
import ChartDataLabels from "chartjs-plugin-datalabels";
import ChartjsPluginStacked100 from "chartjs-plugin-stacked100";
import CheckRadioPicker from "@/components/CheckRadioPicker";
// import JbButton from '@/components/JbButton'
import { useI18n } from "vue-i18n";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Vue3ChartJs from "@j-t-mcc/vue3-chartjs";
import { useRouter } from "vue-router";
import CardComponent from "@/components/CardComponent";
import { AgGridVue } from "ag-grid-vue3";
import Control from "@/components/Control";
import VueSpeedometer from "vue-speedometer";
import CardBoxTransaction from "@/components/CardBoxTransaction";
import CardBoxSiswa from "@/components/CardBoxSiswa";
import CardBoxWaiver from "@/components/CardBoxWaiver";
import { useToast } from "vue-toastification";
export default {
  name: "Home",
  components: {
    Datepicker,
    Field,
    MainSection,
    CheckRadioPicker,
    CardBoxTransaction,
    CardComponent,
    AgGridVue,
    // JbButton,
    Loading,
    Vue3ChartJs,
    Control,
    VueSpeedometer,
    CardBoxSiswa,
    CardBoxWaiver
  },
  data() {
    return {
      context: {},
    };
  },
  setup() {
    const titleStack = ref(["Admin", "Dashboard"]);
    const chartData = ref(null);
    const toast = useToast();
    const isAsideMobileExpanded = computed(
      () => store.state.isAsideMobileExpanded
    );
    const router = useRouter();
    const { t } = useI18n();
    const fillChartData = () => {
      chartData.value = chartConfig.sampleChartData();
    };
    const isLoading = ref(false);
    const rowData = ref({});
    const rowDataCutoff = ref({});
    const rowDataSiswa = reactive([]);
    const rowDataUploadVA = reactive([]);
    const rowDataInvoice = reactive({});
    const rowDataWaiver = reactive({});

    const filter = reactive({
      min_date: new Date(Date.now()).toISOString(),
      max_date: new Date(Date.now()).toISOString(),
      // cutoff: '2023-01-01',
      cutoff: new Date(Date.now()).toISOString(),
      type: true,
      typecalon: true,
      chartfail: 70,
      chartwarning: 90,
      chartsuccess: 100,
      created_by: localStorage.getItem("username"),
    });

    // Pie Chart
    const dataBar = ref([]);
    const chartRefPie = ref(null);
    const groupFin = ref();
    const finLabel = ref([]);
    const pieChart = {
      type: "pie",
      plugins: [ChartDataLabels],
      options: {
        plugins: {
          legend: {
            position: "left",
          },
          datalabels: {
            formatter: (value, ctx) => {
              let sum = 0;
              const dataArr = ctx.chart.data.datasets[0].data;
              // eslint-disable-next-line array-callback-return
              dataArr.map((data) => {
                sum += parseFloat(data);
              });
              const percentage = ((value * 100) / sum).toFixed(1) + "%";
              return percentage;
            },
            color: "white",
            textAlign: "center",
            font: {
              weight: "bold",
              size: 14,
            },
          },
          responsive: true,
        },
        responsive: true,
        borderWidth: 1,
        borderColor: "#ffffff",
        hoverOffset: 10,
        // events: ['click'],
        onClick: function (evt, item) {
          klikDataChart(this.data.labels[item[0].index]);
          groupFin.value = this.data.labels[item[0].index];
          // redirectMenu()
        },
        layout: {
          padding: {
            top: 10,
            bottom: 10,
          },
        },
      },
      data: {
        labels: finLabel,
        datasets: [
          {
            backgroundColor: ["#bc8a5f", "#8b5e34", "#603808", "#f3d5b5"],
            data: dataBar.value,
          },
        ],
      },
    };

    // Data Chart
    const filterDataChart = (evt) => {
      isLoading.value = true;

      axios
        .get("chartall", { params: filter })
        .then((res) => {
          // Pie
          const arrayLength = res.data.data.length;
          const tes = [];
          if (finLabel.value.length > 0) {
            finLabel.value = [];
          }
          for (let i = 0; i < arrayLength; i++) {
            finLabel.value.push(res.data.data[i].incometype);
            tes.push(res.data.data[i].total);
          }

          dataBar.value = tes;
          pieChart.data.labels = finLabel.value;
          pieChart.data.datasets = [
            {
              backgroundColor: [
                "#1d2f6f",
                "#d80e4a",
                "#e0a206",
                "#782132",
                "#2db300",
                "#009999",
                "#4700b3",
                "#990099",
                "#669999",
              ],
              data: dataBar.value,
            },
          ];
          chartRefPie.value.render();
          // End

          // Bar
          rowDataCutoff.value = res.data.cutoffchart;
          rowData.value = res.data.douchart;
          console.log("rowData.value", rowData.value);
          // End

          isLoading.value = false;
        })
        .catch((error) => {
          isLoading.value = false;

          console.log(error);
        });
    };

    // Siswa
    const filterDataSiswa = (evt) => {
      isLoading.value = true;

      axios
        .get("chartsiswa", { params: filter })
        .then((res) => {
          rowDataSiswa.value = res.data.data;
          rowDataUploadVA.value = res.data.uploadva;
          // isLoading.value = false
        })
        .catch((error) => {
          isLoading.value = false;
          console.log(error);
        });
    };
    // End

    const changeValue = (evt) => {
      if (chartRefPie.value) {
        chartRefPie.value.destroy();
      }

      setTimeout(() => {
        filterDataSiswa();
        filterDataSummary();
      }, 500);
    };

    watch(
      () => [filter.cutoff],
      ([newVal, newLev]) => {
        changeValue();
      }
    );

    onBeforeMount(() => {});

    const store = useStore();
    const clientBarItems = computed(() => store.state.clients.slice(0, 3));
    const transactionBarItems = computed(() => store.state.history.slice(0, 3));
    const darkMode = computed(() => store.state.darkMode);

    const klikData = (evt) => {
      const cutoff = new Date(filter.cutoff).toISOString();

      isLoading.value = true;
      localStorage.setItem("categoryid_url", evt.category_id);
      localStorage.setItem("departid_url", evt.department_id);
      localStorage.setItem("siswaid_url", evt.id);
      localStorage.setItem("cutoff_url", cutoff);

      localStorage.setItem("yearid_url", evt.nis);
      localStorage.setItem("levelid_url", evt.nis);
      localStorage.setItem("classid_url", evt.nis);

      window.open("/#/invoicetransaction", "_blank");
      isLoading.value = false;
    };

    const klikDataChart = (evt) => {
      const cutoff = new Date(filter.cutoff).toISOString();

      isLoading.value = true;
      localStorage.setItem("departmentid_url", "ALL");
      localStorage.setItem("cutoff_url", cutoff);
      localStorage.setItem("incometype_url", evt);

      const lastString = evt.substr(evt.length - 1);
      // if (Number.isInteger(lastString)) {
      if (lastString === 1 || lastString === "1") {
        window.open("/#/paymentdashboard", "_blank");
      } else {
        window.open("/#/ardashboard", "_blank");
      }
      // } else {
      // window.open('/#/ardashboard', '_blank')
      // }

      isLoading.value = false;
    };

    const filterDataSummary = (evt) => {
      isLoading.value = true;

      axios
        .get("chartsummary", { params: filter })
        .then((res) => {
          filter.min_date = res.data.min;
          filter.max_date = res.data.max;

          filterDataChart();
          // isLoading.value = false
        })
        .catch((error) => {
          isLoading.value = false;
          console.log(error);
        });
    };

    // Open Payment
    const filteredData = reactive([]);
    const filterDataOpenPayment = (evt) => {
      // isLoading.value = true

      axios
        .get("open-payment", { params: filter })
        .then((res) => {
          filteredData.value = res.data.data;

          // isLoading.value = false
        })
        .catch((error) => {
          // isLoading.value = false
          console.log(error);
        });
    };
    const columnDefs = [
      {
        headerName: "#",
        valueGetter: "node.rowIndex+1",
        pinned: "left",
        minWidth: 60,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
      },
      {
        field: "name",
        headerName: t("Name"),
        sortable: true,
        filter: true,
        suppressSizeToFit: true,
        width: 200,
      },
      {
        field: "class",
        headerName: t("Class"),
        sortable: true,
        filter: true,
        suppressSizeToFit: true,
        width: 100,
      },
      {
        field: "payment_no",
        headerName: t("No. Payment"),
        sortable: true,
        filter: true,
        suppressSizeToFit: true,
        width: 100,
      },
      {
        field: "payment_date",
        headerName: t("Date"),
        sortable: true,
        filter: true,
        suppressSizeToFit: true,
        width: 100,
      },
      {
        field: "payment_reminder",
        headerName: t("Value"),
        sortable: true,
        filter: true,
        suppressSizeToFit: true,
        width: 150,
      },
    ];
    const defaultColDef = {
      resizable: true,
    };
    const generatePayment = (evt) => {
      isLoading.value = true;

      const params = {
        list_generate: closePyamentList,
      };

      axios
        .get("generate-payment", { params })
        .then((res) => {
          filterDataOpenPayment();
          isLoading.value = false;

          if (res.data.success) {
            toast.success(res.data.message, {
              timeout: 5000,
            });
          } else {
            toast.error(res.data.message, {
              timeout: 5000,
            });
          }
        })
        .catch((error) => {
          isLoading.value = false;
          console.log("error", error);
        });
    };
    const closePayment = (evt) => {
      console.log("close payment", closePyamentList);

      if (!closePyamentList || closePyamentList.length < 1) {
        toast.error("Please select payment first.", {
          timeout: 5000,
        });

        return true;
      }

      isLoading.value = true;
      const params = {
        list_close: closePyamentList,
      };

      axios
        .get("close-payment", { params })
        .then((res) => {
          filterDataOpenPayment();
          isLoading.value = false;

          if (res.data.success) {
            toast.success(res.data.message, {
              timeout: 5000,
            });
          } else {
            toast.error(res.data.message, {
              timeout: 5000,
            });
          }
        })
        .catch((error) => {
          isLoading.value = false;
          console.log("error", error);
        });
    };

    const getDataInvoice = async (id) => {
      const headers = { "Content-Encoding": "gzip" };

      try {
        const [responseInvoice, responseWaiverOverdue] = await Promise.all([
          axios.get("accounting-arrears-invoice", { headers, filter }),
          axios.get("accounting-waiver-overdue", { headers, filter }),
        ]);
        if (responseInvoice.data.success) {
          rowDataInvoice.value = responseInvoice.data.data;
        }
        
        if (responseWaiverOverdue.data.success) {
          rowDataWaiver.value = responseWaiverOverdue.data.data;
        }
      } catch (error) {
        console.log(error);
      }
    };

    onMounted(() => {
      filterDataOpenPayment();
      filterDataSiswa();
      fillChartData();
      filterDataSummary();
      getDataInvoice();
    });

    let closePyamentList = [];
    const onRowSelected = (params) => {
      if (params.node.selected == true) {
        let listCandidate = [params.data.payment_id];
        closePyamentList = closePyamentList.concat(listCandidate);
      } else {
        const index = closePyamentList.indexOf(params.data.payment_id);
        if (index > -1) {
          closePyamentList.splice(index, 1);
        }
      }
      closePyamentList = [...new Set(closePyamentList)];
      console.log("closePyamentList", closePyamentList);
    };

    const currencyFormatter = (currency, sign) => {
      if (typeof currency === "string" && currency.includes(",")) {
        currency = currency.replaceAll(",", "");
      }

      if (currency !== undefined) {
        const sansDec = Number(currency).toFixed();
        const formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return `${formatted}`;
      }
    };

    return {
      // Open Payment
      filteredData,
      columnDefs,
      defaultColDef,
      filterDataOpenPayment,
      generatePayment,
      closePayment,

      toast,
      filterDataSiswa,
      filterDataSummary,
      filterDataChart,
      klikDataChart,
      changeValue,
      klikData,
      rowDataCutoff,
      rowData,
      rowDataSiswa,
      rowDataUploadVA,
      router,
      pieChart,
      dataBar,
      finLabel,
      groupFin,
      chartRefPie,
      isLoading,
      t,
      filter,
      titleStack,
      chartData,
      fillChartData,
      clientBarItems,
      transactionBarItems,
      darkMode,
      mdiAccountMultiple,
      mdiCartOutline,
      mdiChartTimelineVariant,
      mdiFinance,
      mdiMonitorCellphone,
      mdiReload,
      mdiGithub,
      mdiMagnify,
      isAsideMobileExpanded,
      rowSelection: null,
      onRowSelected,
      closePyamentList,
      currencyFormatter,
      rowDataInvoice,
      rowDataWaiver
    };
  },
  beforeMount() {
    this.rowSelection = "multiple";
    this.context = {
      componentParent: this,
    };
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      const allColumnIds = [];
      this.gridColumnApi.getAllColumns().forEach((column) => {
        allColumnIds.push(column.colId);
      });
      this.gridColumnApi.autoSizeColumns(allColumnIds, false);
    },
  },
};
</script>

<style>
.full-page-container {
  display: grid;
  grid-template-columns: auto auto;
  gap: 20px;
  transition: width 1s;
}
.dashboard-container {
  background-color: white;
  padding: 15px;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.25);
}
.outstanding-wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.cutoff-container {
  display: flex;
}
.cutoff {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  gap: 50px;
}
.cutoff label {
  width: fit-content;
  white-space: nowrap;
}
.cutoff
  label
  .dp__main.dp__theme_light
  div[aria-label="Datepicker input"]
  .dp__input_wrap
  input.dp__input {
  border-bottom: 0 solid !important;
  box-shadow: 0px 1px 2px #f67638 !important;
  border: 1px solid #f67638;
}

.category-container {
  display: grid;
  font-weight: bold;
  grid-template-columns: auto auto;
  gap: 45px;
  margin: 1rem 0;
  /* border-bottom: 1.25px solid #1c3677; */
}
.select-box {
  display: flex;
  justify-content: space-between;
}
.category-container .select-box div.flex label.checkbox span.check {
  border: 1px solid #f67638;
  margin-right: 3px;
  border-radius: 50%;
}
.category-container
  .select-box
  div.flex
  label.checkbox
  input[type="checkbox"]:checked
  + .check {
  background-image: none !important;
}
.category-container
  .select-box
  div.flex
  label.checkbox
  input[type="checkbox"]:checked
  + .check,
.radio input[type="radio"]:checked + .check {
  background-color: #56b534;
  background-position: center;
  background-repeat: no-repeat;
}

hr.divider {
  border-color: #1c3677;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.25);
  border-width: 1px;
}
.payment-dashboard {
  margin: 1rem 0;
}
.payment-box {
  background: #c9fad3 !important;
  color: black !important;
  border: 2px solid #56b534;
}
.payment-box div.flex-1 {
  padding: 5px 10px;
}
.payment-box div.flex-1 div {
  display: flex;
  flex-direction: column;
  justify-content: left;
  align-items: flex-start;
}
.payment-box div.flex-1 div div div div div {
  flex-direction: column-reverse;
}
.payment-box div.flex-1 div div div div p {
  font-size: 14px;
  margin-top: 0 !important;
}
.payment-box div.flex-1 div div div div h4 {
  font-weight: 600 !important;
}
.payment-box div.flex-1 div div div {
  flex-direction: column-reverse;
}
.payment-box
  div.flex-1
  div.justify-between
  div.flex.items-center.justify-center.mb-6 {
  width: 100% !important;
}
.payment-box
  div.flex-1
  div.justify-between
  div.flex.items-center.justify-center.mb-6
  div.justify-start.items-center.block {
  width: 100% !important;
  padding-bottom: 10px;
  border-bottom: 2px solid #56b534;
}
.payment-box div.flex-1 div div div p {
  font-size: 14px;
  margin-top: 10px !important;
}
.payment-box div.flex-1 div div div h4 {
  font-weight: 600 !important;
}

.invoice-box {
  background: white !important;
  color: black !important;
  border: 2px solid black;
}
.invoice-box div.flex-1 {
  padding: 5px 10px;
}
.invoice-box div.flex-1 div {
  display: flex;
  flex-direction: column;
  justify-content: left;
  align-items: flex-start;
}
.invoice-box div.flex-1 div div div div div {
  flex-direction: column-reverse;
}
.invoice-box div.flex-1 div div div div p {
  font-size: 14px;
  margin-top: 0 !important;
}
.invoice-box div.flex-1 div div div div h4 {
  font-weight: 600 !important;
}
.invoice-box div.flex-1 div div div {
  flex-direction: column-reverse;
}
.invoice-box
  div.flex-1
  div.justify-between
  div.flex.items-center.justify-center.mb-6 {
  width: 100% !important;
}
.invoice-box
  div.flex-1
  div.justify-between
  div.flex.items-center.justify-center.mb-6
  div.justify-start.items-center.block {
  width: 100% !important;
  padding-bottom: 10px;
  border-bottom: 2px solid black;
}
.invoice-box div.flex-1 div div div p {
  font-size: 14px;
  margin-top: 10px !important;
}
.invoice-box div.flex-1 div div div h4 {
  font-weight: 600 !important;
}

.invoice-container {
  overflow-y: auto;
  max-height: 550px;
}
.invoice-container::-webkit-scrollbar {
  width: 0;
}
.invoice-container div.transition-shadow {
  /* background: #ffeeee; */
  border: 2px solid #eb2929;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.25);
  margin-bottom: 15px;
}
.invoice-container div.transition-shadow div.flex-1 {
  padding: 5px 10px;
}
.invoice-container div.transition-shadow div.flex-1 div.block {
  display: flex;
  justify-content: left;
}
.waivers-container {
  overflow-y: auto;
  max-height: 550px;
}
.waivers-container::-webkit-scrollbar {
  width: 0;
}
.waivers-container div.transition-shadow {
  background: lightskyblue;
  border: 2px solid lightslategray;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.25);
  margin-bottom: 15px;
}
.waivers-container div.transition-shadow div.flex-1 {
  padding: 5px 10px;
}
.waivers-container div.transition-shadow div.flex-1 div.block {
  display: flex;
  justify-content: left;
}
.date-picker
  div[aria-label="Datepicker input"]
  div.dp__input_wrap
  input.dp__pointer {
  background: white;
  border: 1px solid #f67638;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);
  padding: 3px;
  padding-left: 35px;
  border-radius: 0px;
}
.rate-container {
  background: white;
  padding: 15px;
  margin-top: 30px;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.25);
}
.input-rate div.mb-6 div div.grid div.form-comp input[type="number"] {
  border: 1px solid #f67638;
}
</style>
